import React from 'react'
import useCurrentUser from '../../hooks/use-current-user'
import AdminHeader from './admin'
import StudentHeader from './student'
import DefaultHeader from './default'

const DynamicHeader = () => {
    const { isBusy, isStudent, isTsc, isAuthorized, isVerified } = useCurrentUser()

    if (!isBusy && isAuthorized && isVerified){
        if (isStudent || isTsc) {
            return (<StudentHeader />)
        }
        return (<AdminHeader />)
    }

    return (<DefaultHeader />)
}

export default DynamicHeader